import { useEffect, useRef, useState } from "react";

/*
 * Inspiration:
 * https://stackoverflow.com/questions/25308823/targeting-positionsticky-elements-that-are-currently-in-a-stuck-state
 * https://developer.chrome.com/blog/sticky-headers/
 */

export const useIsStickingObserver = (isDesktop: boolean) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isSticking, setIsSticking] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (records) => {
        const isSticking = records.some((x) => !x.isIntersecting);
        // Prevent scroll lag by requesting animation frame
        window.requestAnimationFrame(() => setIsSticking(isSticking));
      },
      {
        // listen for intersection 1px off sticking point,
        // i.e. screen top for desktop and bottom of header (56px)
        // for mobile (because mobile header also is sticky)
        rootMargin: `${isDesktop ? -1 : -57}px 0px 0px 0px`,
        threshold: [1],
      }
    );

    const element = ref.current;
    observer.observe(element);

    return () => observer.unobserve(element);
  }, [isDesktop]);
  return { isSticking, ref };
};
